import { Flex } from "antd";
import styled from "styled-components";

export const StyledEmptySalesResultContainer = styled(Flex)`
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    padding: 16px;
    width: 100%;
    background: ${({ theme }) => theme.secondaryBackgroundColor};
    border-radius: 10px;
`;
